import { useContext, useEffect, useReducer } from 'react'
import { useTranslation } from 'react-i18next'
import useNotifications from '../../../hooks/useNotifications'
import { getGroupReservations } from '../../../services/groupsService'
import { deepCopy } from '../../../util/Utils'
import { GroupContext } from '../GroupContextProvider'

// Constants
const actions = {
  REFETCH_RESERVATIONS: 'REFETCH_RESERVATIONS',
  SET_GROUP_RESERVATIONS_DATA: 'SET_GROUP_RESERVATIONS_DATA',
}

function groupReservationsReducer(oldState, action) {
  const newState = deepCopy(oldState)
  const { payload, type } = action

  switch (type) {
    case actions.REFETCH_RESERVATIONS: {
      newState.refetchReservations = !newState.refetchReservations
      break
    }
    case actions.SET_GROUP_RESERVATIONS_DATA: {
      newState.personData = payload.personData
      newState.reservations = payload.reservations
      newState.userNames = payload.userNames
      break
    }
    default:
      break
  }
  return newState
}

export default function useGroupReservations() {
  const { t } = useTranslation()
  const { error } = useNotifications()
  const { currentGroupData } = useContext(GroupContext)
  // Initial State
  const initialState = {
    personData: {},
    refetchReservations: false,
    reservations: null,
    userNames: {},
  }
  // Reducer Hook
  const [groupReservationsState, groupReservationsDispatch] = useReducer(groupReservationsReducer, initialState)
  // Effects
  useEffect(() => {
    let isCurrent = true
    if (currentGroupData.id) {
      getGroupReservations(currentGroupData.id)
        .then((response) => {
          if (isCurrent) {
            groupReservationsDispatch({ type: actions.SET_GROUP_RESERVATIONS_DATA, payload: response.data })
          }
        })
        .catch((err) => {
          error(
            t('groups.errors.retrievingGroupReservations', {
              defaultValue: `Error retrieving group reservations: ${err.message || ''}`,
              message: err.message || '',
            }),
            err
          )
        })
    }
    return () => {
      isCurrent = false
    }
  }, [error, currentGroupData.id, groupReservationsState.refetchReservations, t])
  // Functions
  const refetchReservations = () => {
    groupReservationsDispatch({ type: actions.REFETCH_RESERVATIONS })
  }
  // Variables
  // Helpers
  const helpers = {
    refetchReservations,
  }
  return [groupReservationsState, helpers]
}
